import { useEffect } from "react";
import Hero from "@/components/Hero";
import Benefits from "@/components/Benefits";
import Feedback from "@/components/Feedback";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import { trackVisit } from "@/lib/tracker";

export default function Landing() {
    useEffect(() => {
        trackVisit(window.location.pathname || "/");
    }, []);

    return (
        <SmoothScroll>
            <div data-testid="landing-page" className="grain">
                <Hero />
                <Benefits />
                <Feedback />
                <Footer />
            </div>
        </SmoothScroll>
    );
}
